import { createFileRoute } from '@tanstack/react-router';
import { Field } from '@osd/ui/field';
import { Stack } from '@osd/ui/stack';
import { Textarea } from '@osd/ui/textarea';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/textarea — live docs for the `Textarea` primitive.
 */
export const Route = createFileRoute('/ui/_layout/textarea')({
  component: TextareaPage,
});

function TextareaPage() {
  return (
    <Stack gap={6}>
      <Section title="Textarea" hint="multi-line text input — inherits Input styles via @extend">
        <Stack gap={3}>
          <Field label="Bio" hint="Tell us a bit about yourself.">
            <Textarea name="bio" rows={4} placeholder="I build things…" />
          </Field>
          <Field label="Notes">
            <Textarea name="notes" rows={6} />
          </Field>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Basic — uncontrolled"
            language="tsx"
            code={`<Field label="Notes">
  <Textarea name="notes" rows={6} />
</Field>`}
          />

          <CodeBlock
            title="With placeholder + hint"
            language="tsx"
            code={`<Field label="Bio" hint="Max 280 characters.">
  <Textarea name="bio" rows={4} placeholder="I build things…" />
</Field>`}
          />

          <CodeBlock
            title="Controlled — with useForm"
            language="tsx"
            code={`<Field
  label="Description"
  error={form.touched.description ? form.errors.description : null}
>
  <Textarea
    name="description"
    rows={6}
    value={form.values.description}
    onChange={form.handleChange}
    onBlur={form.handleBlur}
  />
</Field>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
